/**
 * Status badge with colored dot indicator.
 * Used across CRM, invoicing, and employee views.
 */

const STATUS_CONFIG = {
  "Active Project": { bg: "#E8F5E9", color: "#2E7D32", dot: "#4CAF50" },
  "Estimate Sent": { bg: "#FFF3E0", color: "#E65100", dot: "#FF9800" },
  "Completed": { bg: "#E3F2FD", color: "#1565C0", dot: "#2196F3" },
  "Lead": { bg: "#F3E5F5", color: "#7B1FA2", dot: "#9C27B0" },
  "Paid": { bg: "#E8F5E9", color: "#2E7D32", dot: "#4CAF50" },
  "Pending": { bg: "#FFF3E0", color: "#E65100", dot: "#FF9800" },
  "Draft": { bg: "#ECEFF1", color: "#546E7A", dot: "#90A4AE" },
  "Overdue": { bg: "#FFEBEE", color: "#C62828", dot: "#F44336" },
};

export default function StatusBadge({ status }) {
  const c = STATUS_CONFIG[status] || STATUS_CONFIG["Draft"];
  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6, padding: "4px 12px", borderRadius: 20, background: c.bg, color: c.color, fontSize: 12, fontWeight: 600, fontFamily: "'DM Sans', sans-serif" }}>
      <span style={{ width: 7, height: 7, borderRadius: "50%", background: c.dot }} />
      {status}
    </span>
  );
}
